import {css} from 'lit';
export const styles = css`:host {
  position: relative;
  display: block;
  height: 100%;
}

lit-virtualizer {
  height: 100%;
  height: var(--chat-list-virtualizer-height, 100%);
}

lit-virtualizer > * {
  width: 100%;
}

lit-virtualizer > *:not(:first-child) {
  margin-top: 8px;
  margin-top: var(--chat-list-virtualizer-margin-top, 8px);
}

lit-virtualizer > .spacer {
  margin-top: 0;
  height: 0;
  height: var(--chat-list-virtualizer-spacer, 0);
}

.back-to-top {
  position: absolute;
  bottom: 0;
  right: 50%;
  z-index: 2;
  background-color: var(--contrast-dark);
  color: var(--contrast-light);
  border: none;
  text-align: center;
  opacity: 0.5;
  padding: 4px 16px;
  padding: var(--chat-list-back-btn-padding, 4px 16px);
  font-size: 1.5em;
  transform: translateX(50%);
}

@media (hover: hover) {

.back-to-top {
    cursor: pointer
}

    .back-to-top:hover {
      opacity: 1;
    }
  }

.back-to-top:active {
    opacity: 0.8;
  }

.indicators {
  position: absolute;
  bottom: 0;
  padding-left: 8px;
  padding-right: 8px;
  background-color: var(--contrast-light);
  opacity: 0.8;
}
`;
export default styles;
